<template>
  <div class="adv">
    <div v-if="schoolCode === '10488'" data-v-af5d225e="" data-v-03dd2030="" class="header"  @click="goBack()">
      <div data-v-af5d225e="">
        <i data-v-af5d225e="" class="back"></i>
        <h3 data-v-af5d225e="">已收公告</h3>
      </div>
    </div>
    <Header v-else title="已收公告" type="0" route="/new/Msg"></Header>
    <NOdata title="暂无消息~" v-if="this.advLists.length == 0"></NOdata>
    <div v-else class="adv_main">
      <div
        class="adv_item"
        v-for="(item, index) in advLists"
        :key="index"
        @click="open(item)"
      >
        <div class="adv_item_header">
          <span :class="{ header_img: true, imgWd: item.isck == '0' }"></span>
          <h3 class="header_text">{{ item.gglbname ? item.gglbname : "-" }}</h3>
        </div>
        <div class="adv_item_content">
          <div class="content_title">
            <span v-if="item.sfzd === '1'" class="content_zhiding">置顶</span>
            <h3 class="content_text">{{ item.ggbt ? item.ggbt : "-" }}</h3>
          </div>
          <div class="adv_item_info">
            <p>{{ item.cjr ? item.cjr : "-" }} 发布</p>
            <p>{{ item.ggfbsj ? item.ggfbsj : "-" }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="Identity == 1 && schoolCode == '14475' && isfban"
      class="adv_main_button"
      @click="apply"
    >
      <van-icon name="plus" />
      <span>发布公告</span>
    </div>
    <div class="back_top" @click="backTop">
      <van-icon name="back-top" />
    </div>
    <van-popup class="successPopup" v-model="isShow">
      <van-icon
        @click="isShow = false"
        class="successPopup_icon"
        name="cross"
      />
      <img
        class="successPopup_img"
        :src="require(`@/assets/images/successPopup.png`)"
        alt=""
      />
      <h2 class="successPopup_msg">恭喜发布成功</h2>
      <div @click="isShow = false" class="successPopup_button">
        知道了
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      isfban: false,
      isShow: false,
      advLists: [],
      Identity: sessionStorage.getItem("Identity"),
      schoolCode: sessionStorage.getItem("schoolCode")
    };
  },
  created() {
    this.getList();
    this.isShow = this.$route.query.isSuccess == 1;
  },
  methods: {
    apply() {
      this.$router.push({ path: "/applyAdvItem" });
    },
    backTop() {
      $(".adv")[0].scrollTop = 0;
    },
    async getList() {
      const res = await Api.getAdvList();
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          cjr: item.cjr,
          yyzt: item.yyzt,
          ggfbsj: item.ggfbsj,
          ggbt: item.ggbt,
          ggid: item.ggid,
          gglbname: item.gglbname,
          isck: item.isck
        };
      });
      this.advLists = concatList;
      this.isfban = res.isfban;
    },
    open(item) {
      this.$router.push({
        name: "advItem",
        params: {
          ggid: item.ggid,
          gglbname: item.gglbname,
          isck: item.isck
        }
      });
    },
    goBack() {
      this.$router.push({
        path: '/new/Msg_10488',
        query: {
          active:1
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.adv {
  height: 100%;
  background-color: #f2f2f4;
  box-sizing: border-box;
  overflow: auto;
  .adv_main {
    padding: 12px 15px;

    .adv_item {
      background: #ffffff;
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      margin-bottom: 12px;
      .adv_item_header {
        display: flex;
        align-items: center;
        height: 40px;
        padding: 0 15px;
        border-bottom: 1px solid #e5e5e5;
        .header_img {
          width: 24px;
          height: 24px;
          background-image: url("~@/assets/images/imgYd.png");
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          &.imgWd {
            background-image: url("~@/assets/images/imgWd.png");
          }
        }
        .header_text {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #666666;
          font-weight: 400;
          margin-left: 8px;
        }
      }
      .adv_item_content {
        padding: 12px 15px;
        .content_title {
          display: flex;
          align-items: center;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #333333;
          font-weight: bolder;
          line-height: 22px;
          margin-bottom: 14px;
          .content_zhiding {
            width: 32px;
            height: 20px;
            border: 1px solid #7469f8;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #7469f8;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            line-height: 17px;
            margin-right: 10px;
          }
        }
      }
      .adv_item_info {
        display: flex;
        justify-content: space-between;
        p {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #999999;
          line-height: 12px;
          font-weight: 400;
        }
      }
    }
  }

  .adv_main_button {
      position: fixed;
      left: 50%;
      bottom: 60px;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 215px;
      height: 44px;
      background-color: #7469f8;
      box-shadow: 0px 4px 8px 0px rgba(116, 105, 248, 0.2);
      border-radius: 25px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      line-height: 16px;
      color: #ffffff;
      font-weight: bolder;
      .van-icon {
        margin-right: 8px;
        font-size: 14px;
        border: 1.5px solid #fff;
        border-radius: 2px;
      }
    }
  .back_top {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 8px;
    bottom: 20%;
    width: 40px;
    height: 40px;
    background: #7469f8;
    background-color: #7469f8;
    border-radius: 50%;
    .van-icon {
      color: #fff;
      font-weight: bolder;
      font-size: 25px;
    }
  }
  .successPopup {
    box-sizing: border-box;
    width: 256px;
    height: 318px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 66px;
    .successPopup_icon {
      font-size: 20px;
      position: absolute;
      top: 15px;
      right: 15px;
      color: #999999;
    }
    .successPopup_img {
      width: 137.08px;
      height: 110px;
      margin-bottom: 20px;
    }
    .successPopup_msg {
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #7469f8;
      letter-spacing: 0;
      text-align: center;
      font-weight: 600;
    }
    .successPopup_button {
      width: 100%;
      position: absolute;
      bottom: 0;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #7469f8;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      border-top: 1px solid #e5e5e5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Adv.vue